import { render, staticRenderFns } from "./DiscountItem.vue?vue&type=template&id=2134db5e&scoped=true&"
import script from "./DiscountItem.vue?vue&type=script&lang=js&"
export * from "./DiscountItem.vue?vue&type=script&lang=js&"
import style0 from "./DiscountItem.vue?vue&type=style&index=0&id=2134db5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2134db5e",
  null
  
)

export default component.exports